import React from 'react'
import injectSheet from 'react-jss'
import MediaIcon from 'aria-viewer/tour/components/MediaIcon'
import { MEDIA_TYPES, NETWORK_TYPES } from 'aria-viewer/tour/constants'
import CampusreelThumbnail from 'aria-viewer/tour/components/buttons/supplementalmedia/campusreelThumbnail'
import ThumbVideo from 'public/assets/svg/thumb_video.svg'

const styleSheet = {
    container: {
        width: '324px',
    },
    img: {
        height: '186px',
        width: '100%',
        borderRadius: '5px',
        background: ({ media }) => `url(${media?.urls?.tiny}) no-repeat center center / cover`,
        cursor: 'pointer',
        position: 'relative',
    },
    instagram: {
        height: '186px',
        width: '100%',
        borderRadius: '5px',
        cursor: 'pointer',
        position: 'relative',
        overflow: 'hidden',
    },
    iframe: {
        pointerEvents: 'none',
        position: 'absolute',
        height: '140%',
        width: '100%',
        top: '-70px',
    },
    title: {
        color: ({ isDeviceMobile }) => (isDeviceMobile ? '#fff' : 'rgba(5, 29, 57, 1)'),
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '20px',
        padding: '10px 0',
        textWrap: 'wrap',
    },
    category: {
        color: 'rgba(99, 115, 164, 1)',
        fontSize: '12px',
        fontWeight: 450,
        lineHeight: '18px',
        textWrap: 'wrap',
    },
    thumbnailIcon: {
        position: 'absolute',
        right: '22px',
        bottom: '15px',
    },
}

const ResultCell = ({ classes, result, stop, onResultClick, media, isDeviceMobile }) => {
    const network = media && media.network ? media.network : null
    return media ? (
        <div className={classes.container}>
            {network === NETWORK_TYPES.instagram ? (
                <div className={classes.instagram} onClick={e => onResultClick(e, result)}>
                    <iframe
                        className={classes.iframe}
                        src={`https://www.instagram.com/p/${
                            media.mediaType === MEDIA_TYPES.photo ? media?.url : media?.videoid
                        }/embed`}
                        frameBorder="0"
                        allowFullScreen=""
                        scrolling="no"
                    ></iframe>
                    <div className={classes.thumbnailIcon}>
                        <MediaIcon mediaType={result.media_type} network={network} showBackground={false} />
                    </div>
                </div>
            ) : media.type === 'campusreel' ? (
                <div className={classes.img} onClick={e => onResultClick(e, result)}>
                    <CampusreelThumbnail
                        embedId={media?.url || media?.videoId}
                        media={media}
                        width={324}
                        height={190}
                        top={0}
                        left={0}
                        iframeHeight={'102%'}
                        iframeWidth={'102%'}
                        img={ThumbVideo}
                    />
                    <div className={classes.thumbnailIcon}>
                        <MediaIcon
                            mediaType={result.media_type}
                            network={network}
                            showBackground={false}
                            type="campusreel"
                        />
                    </div>
                </div>
            ) : (
                <div className={classes.img} onClick={e => onResultClick(e, result)}>
                    <div className={classes.thumbnailIcon}>
                        <MediaIcon
                            mediaType={result.media_type}
                            network={network}
                            showBackground={false}
                            type={media.type}
                        />
                    </div>
                </div>
            )}
            <div className={classes.title}>{result.media_type === MEDIA_TYPES.stop ? stop?.title : media?.title}</div>
        </div>
    ) : null
}

export default injectSheet(styleSheet)(ResultCell)
